
export interface AdminAccountSubscriptionEventTimelineItem {
  /** @nullable */
  createdAt?: string | null;
  /** @nullable */
  deltaDays?: number | null;
  /** @nullable */
  description?: string | null;
  /** @nullable */
  eventType?: string | null;
  /** @nullable */
  id?: number | null;
  /** @nullable */
  newEndDate?: string | null;
  /** @nullable */
  previousEndDate?: string | null;
}
